import ApplicationSerializer from './application';

export default class GlobalSignInFieldActionsContactSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key) {
    if (key === 'sign-in-field-action-rule-groups') {
      return 'global-sign-in-field-action-rule-group';
    } else if (key === 'sign-in-field-actions-contacts') {
      return 'global-sign-in-field-actions-contact';
    } else if (key === 'sign-in-field-actions') {
      return 'global-sign-in-field-action';
    } else {
      return super.modelNameFromPayloadKey(...arguments);
    }
  }

  payloadKeyFromModelName(modelName) {
    if (modelName === 'global-sign-in-field-action-rule-group') {
      return 'sign-in-field-action-rule-groups';
    } else if (modelName === 'global-sign-in-field-actions-contact') {
      return 'sign-in-field-actions-contacts';
    } else {
      return super.payloadKeyFromModelName(...arguments);
    }
  }
}
